import React, { createContext, useState, useEffect, useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useWidgetContext } from "src/context/WidgetContext";
import { useAuth } from "./AuthContext";

// Create a context for global notifications
export const GlobalNotificationsContext = createContext();

export const GlobalNotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [error, setError] = useState(null);
  const { isLoggedIn, subUserData } = useAuth();

  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchNotifications = async () => {
    try {
      if (!isAuthenticated || !user || !user.sub || !subUserData || !subUserData.user_id) return;
  
      const accessToken = await getAccessTokenSilently();
  
      const response = await fetch(`${apiUrl}/api/in-app-notifications/user/notifications`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          userId: user.sub, // Auth0 user ID
          subUserID: subUserData.user_id, // Sub-user ID
        }),
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch notifications");
      }
  
      const data = await response.json();
      setNotifications(data.notifications);
  
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setError(error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [apiUrl, isAuthenticated, user, isLoggedIn, subUserData]);




  return (
    <GlobalNotificationsContext.Provider
      value={{
        notifications,
        setNotifications,
        fetchNotifications,
        error,

      }}
    >
      {children}
    </GlobalNotificationsContext.Provider>
  );
};

// Custom hook to use global notifications context
export const useGlobalNotifications = () =>
  useContext(GlobalNotificationsContext);
